import axiosInstance from '../../api/axiosInstance';
import { RolePermissionsResponse } from '../../types/permissions/rolePermissionsResponse';

export const rolePermissionService = {
  // Obtener permisos de un rol
  getRolePermissions: async (roleId: number): Promise<RolePermissionsResponse> => {
    const response = await axiosInstance.get<RolePermissionsResponse>(`/users/roles/${roleId}/permissions`);
    return response.data;
  },

  // Actualizar permisos de un rol
  updateRolePermissions: async (roleId: number, permissionIds: number[]): Promise<RolePermissionsResponse> => {
    const response = await axiosInstance.post<RolePermissionsResponse>(`/users/roles/${roleId}/permissions`, {
      role_id: roleId,
      permission_ids: permissionIds
    });
    return response.data;
  }
};
